import React, { Component } from "react";

import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { Spring } from "react-spring";
import Swal from "sweetalert2";

import {
  CounsellorsActions,
  alertActions,
  LanguagesActions,
} from "../../store/actions";
import { constants } from "../../Constants";
import HeaderComponent from "../../components/Header";
import Footer from "../../components/Footer/footer";
import "../../static/css/styles.css";

import Loading from "../../components/Loading/Loading";
import { API_ROOT_URL } from "../../config";
import EditImage from "../../static/images/edit.svg";
import DeleteImage from "../../static/images/delete.svg";
import DummyImage from "../../static/images/dashboard-dummy-image.svg";
import { history } from "../../helpers/history";
import "../../static/css/styles.css";
import wellbeingIcon from "../../static/images/wellbeing.svg";
import nutrionistIcon from "../../static/images/nutrionist.svg"
import { sortByDateCreated } from "../../helpers/utils";

class Counsellors extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentWillMount() {
    this.props.fetchCounsellors();
    this.props.fetchLanguages();
  }

  toggleLoading = (status) => {
    this.setState({ loading: status });
  };

  deleteCounsellor = () => {
    Swal.fire({
      title: constants.ARE_YOU_SURE_TXT,
      text: constants.DELETE_COUNSELLOR_TXT,
      type: constants.WARNING_TXT,
      icon: constants.ERROR_TEXT,
      showCancelButton: true,
      reverseButtons: true,
      confirmButtonColor: "#36A692",
      cancelButtonColor: "#d33",
      cancelButtonText: constants.NO_TXT,
      confirmButtonText: constants.YES_TXT,
      footer: "<a href>Contact Administrator?</a>",
    });
  };

  editCounsellor = (id) => {
    if (id !== "") this.props.selectCounsellor(id);
    history.push("/update-counsellor");
  };

  createWLText = (obj) => {
    let result = [];
    if (obj && obj.project_details && obj.project_details.length > 0) {
      obj.project_details.map((w) => {
        if(!w.is_deleted){
          return result.push(w.name);
        }
      });
      return result.join(", ");
    } else return "N/A";
  };
  render() {
    const { counsellors, loading } = this.props;

    if (loading) {
      return <Loading />;
    } else {
      const sortedCounsellors = sortByDateCreated(counsellors, "counsellor_details.counsellor_date_created");
      return (
        <div className="ContainerFix">
          <HeaderComponent />
          <Spring
            from={{ transform: "translate(+100%, 0)" }}
            to={{ transform: "translate(0%, 0)" }}
          >
            {(props) => (
              <div className="" style={props}>
                <div
                  className="row mt-5 mx-auto w-75 pb-5"
                  id="cardButtonContainer"
                >
                  <div className="heading-container">
                    <p className="lead heading-line">{constants.COUNSELLORS}</p>
                    <p className="lead heading-text">
                      {constants.LIST_COUNSELLORS_TXT}
                    </p>
                    <hr className="lead--heading-line" />
                  </div>

                  {/* FORM STARTS */}
                  <form className="form-inline">
                    <div className="col-md-8 col-sm-12 p-0">
                      <input
                        className="form-control form-control-lg mr-sm-8 search-input"
                        type="text"
                        placeholder="Search"
                      />
                    </div>
                    <div className="col-md-4 col-sm-12 counsellor-btns">
                      <div className="dropdown">
                        <a className="btn btn-lg btn-counsellor dark-green mr-1">
                          Filter&nbsp;
                          <i className="fa fa-caret-down"></i>
                        </a>
                        <div className="dropdown-content">
                          <a href="#">Filter 1</a>
                          <a href="#">Filter 2</a>
                        </div>
                      </div>
                      <button
                        className="btn btn-lg btn-counsellor dark-blue"
                        aria-pressed="true"
                        role="button"
                        type="submit"
                      >
                        {constants.SEARCH_TXT}
                      </button>
                    </div>
                  </form>
                  {/* FORM ENDS */}

                  {/* CARD STARTS */}
                  {Array.isArray(sortedCounsellors) &&
                    sortedCounsellors.length > 0 &&
                    sortedCounsellors.map((c) => {
                      const languagesSpoken =
                        c.counsellor_details.languages &&
                          c.counsellor_details.languages.length > 0
                          ? c.counsellor_details.languages
                            .join(", ")
                            .replace(/, ([^,]*)$/, " and $1")
                          : "N/A";
                      const seriveTypeIcon = c.counsellor_details.service_type.code === 'wellbeing' ? wellbeingIcon : nutrionistIcon;
                      return (
                        <div className="card bg-light text-dark lead--card-heading">
                          <div className="card-body m-2">
                            <div className="row">
                              <div className="col-md-2 col-sm-3 counsellor-img">
                                <img
                                  src={c.counsellor_details.picture}
                                  alt="Avatar"
                                  className="avatar-counsellor counsellor-photo"
                                  width="130px"
                                  height="130px"
                                />
                              </div>
                              <div className="col-md-7 col-sm-6">
                                <div className="d-flex flex-column flex-md-row service-tag-container">
                                  {/* Name */}
                                  <span className="card--list-name counsellor-project text-nowrap">
                                    {c.user_details.full_name}
                                  </span>
                                  {/* Service Type Tag */}
                                  <div
                                    className="d-flex align-items-center service-tag-inner-container counsellor-project">
                                    <img
                                      src={seriveTypeIcon}
                                      className={`counsellor-image-icon ${c.counsellor_details.service_type.code === 'wellbeing' ? 'mr-1' : 'mr-015'}`}
                                      width={c.counsellor_details.service_type.code === 'wellbeing' ? 14 : 18}
                                    />
                                    <span className="serive-tag-name-style ">{c.counsellor_details.service_type.name}</span>
                                  </div>
                                </div>
                                <div className="row counsellor-details">
                                  <div className="col-md-6 col-sm-12">
                                    <ul className="list-counsellor-details p-0">
                                      <li>
                                        {`${constants.EMAIL_TXT}: ${c.user_details.email}`}
                                      </li>
                                      <li>
                                        {`${constants.PHONE_TXT}: ${c.counsellor_details.contact_number}`}
                                      </li>
                                      <li>
                                        {`${constants.EXPERT_AREA}: ${c.counsellor_details.area_of_expertise}`}
                                      </li>
                                      <li>
                                        {`${constants.LANGUAGES_TXT}: ${languagesSpoken}`}
                                      </li>
                                    </ul>
                                  </div>
                                  <div className="col-md-6 col-sm-12">
                                    <ul className="list-counsellor-details p-0">
                                      <li>
                                        {`${
                                          constants.PRICE_USD_TXT +
                                          ": " +
                                          (c.counsellor_details.price_usd &&
                                            c.counsellor_details.price_usd !== 0
                                            ? c.counsellor_details.price_usd
                                            : "N/A")
                                          }`}
                                      </li>
                                      <li>
                                        {`${
                                          constants.PRICE_PKR_TXT +
                                          ": " +
                                          (c.counsellor_details.price_pkr &&
                                            c.counsellor_details.price_pkr !== 0
                                            ? c.counsellor_details.price_pkr
                                            : "N/A")
                                          }`}
                                      </li>
                                      <li>
                                        {`${constants.QUALIFICATION_TXT}: ${c.counsellor_details.qualifications}`}
                                      </li>
                                      <li>
                                        {`${
                                          constants.RELATION_WITH_WHITELABEL_TXT
                                          }: ${this.createWLText(c)}`}
                                      </li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div className="col-3 counsellor-actions">
                                <div className="card--icons-text counsellor-icons-text">
                                  <div
                                    className="card--icon counsellor-card--icon"
                                    onClick={() =>
                                      this.editCounsellor(
                                        c.counsellor_details.counsellor_id
                                      )
                                    }
                                  >
                                    {" "}
                                    <img
                                      className="card--image-icons"
                                      src={EditImage}
                                      alt="edit icon"
                                    />
                                    <span className="card--ico-text">
                                      {constants.EDIT_TXT}
                                    </span>
                                  </div>
                                  <div
                                    className="card--icon counsellor-card--icon m-0"
                                    onClick={this.deleteCounsellor}
                                  >
                                    <img
                                      className="card--image-icons"
                                      src={DeleteImage}
                                      alt="delete icon"
                                    />
                                    <span className="card--ico-text">
                                      {constants.DELETE_TXT}
                                    </span>
                                  </div>
                                  <p className="counsellor-status">
                                    {constants.ACTIVE_TXT}
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    })}
                  {/* CARD ENDS */}
                </div>
              </div>
            )}
          </Spring>
          <Footer />
        </div>
      );
    }
  }
}

function mapStateToProps(state) {
  const { alert } = state;
  const authstate = state.auth;
  const { counsellors, selectedCounsellor, loading } = state.counsellors;

  return {
    alert,
    authstate,
    counsellors,
    selectedCounsellor,
    loading,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    selectCounsellor: (id) => {
      dispatch(CounsellorsActions.selectCounsellor(id));
    },
    resetWhitelabel: () => {
      dispatch(CounsellorsActions.resetCounsellor());
    },
    fetchCounsellors: () => {
      dispatch(CounsellorsActions.fetchCounsellors());
    },
    clearAlertActions: () => {
      dispatch(alertActions.clear());
    },
    alertError: (message) => {
      dispatch(alertActions.error(message));
    },
    fetchLanguages: () => {
      dispatch(LanguagesActions.fetchLanguages());
    },
  };
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Counsellors)
);



// WEBPACK FOOTER //
// ./src/screens/Counsellors/index.js